// extracted by mini-css-extract-plugin
export default {"container":"Howtouse_container__EL8uX","title":"Howtouse_title__TmAWW","description1":"Howtouse_description1__CU5R7","description":"Howtouse_description__+5sYY"};